import { labelZodObject } from "@@/shared/labels/label";
import {
    translatableReqZodUnion,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";
import {
    productFormFieldIdFactory,
    productFormFieldIdZodSchema,
} from "../fields/product-form-field-id";
import { productFormFieldQuantityZodUnion } from "../fields/product-form-field-quantity";
import { productFormFieldSelectOptionZodObject } from "../fields/select-field/product-form-field.select-option";

const selectDataZodObject = z.object({
    fieldId: productFormFieldIdZodSchema,
    fieldType: z.literal("SELECT"),
    quantity: productFormFieldQuantityZodUnion,
    title: translatableReqZodUnion,
    description: translatableZodSchema,
    // TODO! Add support for multi choice and multi select
    // TODO! Since we do not have that yet, for now, "There can be only one"
    minRequired: z.number().int().positive().min(1).max(1),
    maxRequired: z.number().int().positive().min(1).max(1),
    defaultValues: z.array(z.string()),
    options: z.array(productFormFieldSelectOptionZodObject).min(1),
    labels: z.array(labelZodObject),
});
type SelectData = z.infer<typeof selectDataZodObject>;

const _factoryParamsZodObject = selectDataZodObject
    .omit({
        fieldId: true,
        fieldType: true,
    })
    .and(
        z.object({
            fieldId: productFormFieldIdZodSchema.optional(),
        }),
    );
type FactoryParams = z.infer<typeof _factoryParamsZodObject>;

const selectDataFactory = (input: FactoryParams): SelectData => {
    return {
        ...input,
        fieldId: input.fieldId ?? productFormFieldIdFactory(),
        fieldType: "SELECT",
    };
};

export { selectDataFactory, selectDataZodObject };
export type { SelectData, FactoryParams as SelectDataFactoryParams };
